import React from 'react';
import isEmpty from 'lodash-es/isEmpty';

import { ReactComponent as DocumentIcon } from '../assets/images/document.svg';
import {
  PROGRESS_QUESTIONS,
  PROGRESS_VALUES,
  QUESTION_KEYS,
  WEB_LINKS,
} from '../constants/strengthenQuestionsConstants';

export const formatURLType = (selectedType) => {
  if (selectedType) {
    const linkType = WEB_LINKS.find(({ type }) => type === selectedType);
    if (linkType) {
      return linkType;
    }
  }
};

export const formatCandidateQuestions = (initialValues, data) => {
  const newData = { ...initialValues };

  const { questions, links_json, skills, resume_file_links } = data;

  if (!isEmpty(questions)) {
    Object.entries(questions).forEach(([key, value]) => {
      if (key === 'diversity_hire') {
        newData[key] = value;
      } else if (!isEmpty(value)) {
        if (key === 'joining_date') {
          newData[key] = new Date(value);
        } else {
          newData[key] = value;
        }
      }
    });
  }

  if (!isEmpty(links_json)) {
    newData.links_json = links_json;
  }

  if (!isEmpty(skills)) {
    newData.candidate_skills = skills;
  }

  if (!isEmpty(resume_file_links)) {
    newData.files = resume_file_links;
  }

  return newData;
};

export const formatDateFormat = (data) => {
  if (isEmpty(String(data))) {
    return '';
  }

  const date = new Date(data);
  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};

const formatFiles = (files) => {
  const newFiles = [];
  const oldFiles = [];

  files.forEach((file) => {
    const { id, _destroy } = file;

    if (id) {
      if (!_destroy) {
        oldFiles.push(id);
      }
    } else {
      newFiles.push({ pdf: file[0] });
    }
  });
  return { newFiles, oldFiles };
};

export const formatSubmitedVales = (data) => {
  const { candidate_skills, links_json, files } = data;
  const newData = { ...data };
  const submissionData = {};

  newData.joining_date = formatDateFormat(data.joining_date);

  submissionData.skill_ids = candidate_skills.map(({ id }) => id);
  submissionData.links_json = links_json.filter(({ value }) => !!value);
  submissionData.general_question_attributes = {
    questions: QUESTION_KEYS.map((key) => ({ answer: newData[key], question: key })),
  };

  const updatedFiles = formatFiles(files);
  submissionData.pdf_file_ids = updatedFiles.oldFiles;

  submissionData.location = data.location;

  return { candidate: submissionData, pdfFiles: updatedFiles.newFiles };
};

export const candidateQuestionsSuccess = (data, styles, t) => {
  const { skills, questions } = data;
  const questionsList = [];

  PROGRESS_VALUES.forEach((value) => {
    if (value === 'skills' && !isEmpty(skills)) {
      questionsList.push(
        <div key={`step-${value}`} className={styles.questionContainer}>
          <span className={styles.question}>{t(PROGRESS_QUESTIONS[value])} &nbsp;</span>
          <span>{skills.map(({ name }) => name).join(', ')}</span>
        </div>
      );
    } else if (!isEmpty(questions[value])) {
      questionsList.push(
        <div key={`step-${value}`} className={styles.questionContainer}>
          <span className={styles.question}>{t(PROGRESS_QUESTIONS[value])} </span>
          <span className={styles.answer}>{questions[value]}</span>
        </div>
      );
    }
  });

  questionsList.push(
    <div className={styles.questionContainer}>
      <span className={styles.question}>{t(PROGRESS_QUESTIONS.diversity_hire)} </span>
      <span className={styles.answer}>{questions.diversity_hire ? t('yes') : t('no')}</span>
    </div>
  );

  return questionsList;
};

export const userFilesSuccess = (data, styles) => {
  const { resume_file_links } = data;
  const filesList = [];

  resume_file_links.forEach(({ id, name }) =>
    filesList.push(
      <span key={id} className={styles.filesContainer}>
        <DocumentIcon />
        {name}
      </span>
    )
  );

  return filesList;
};
